<div class="main">
  <div class="header">
    <div  class="text">
      {{ 'PAYMENT_VOUCHER_VIEW.title' | translate}}
    </div>
    <i class="material-icons" (click)="closeModal();">clear</i>
  </div>
  <div class="section">
      <div class="details">
          <div class="detail">
              <div class="label">
                  {{ 'PAYMENT_VOUCHER_VIEW.voucher_no' | translate}}
              </div>
              <div class="colon">
                  :
              </div>
              <div class="value">
                  {{ voucherData.voucher_no }}
              </div>
          </div>
          <div class="detail">
              <div class="label">
                  {{ 'PAYMENT_VOUCHER_VIEW.date_of_payment' | translate}}
              </div>
              <div class="colon">
                  :
              </div>
              <div class="value">
                  {{ voucherData.date_of_payment }}
              </div>
          </div>
          <div class="detail">
              <div class="label">
                  {{ 'PAYMENT_VOUCHER_VIEW.creation_date' | translate}}
              </div>
              <div class="colon">
                  :
              </div>
              <div class="value">
                  {{ voucherData.creation_date }}
              </div>
          </div>
          <div class="detail">
              <div class="label">
                  {{ 'PAYMENT_VOUCHER_VIEW.payee' | translate}}
              </div>
              <div class="colon">
                  :
              </div>
              <div class="value">
                  {{ voucherData.payee }}
              </div>
          </div>
          <div class="detail">
              <div class="label">
                  {{ 'PAYMENT_VOUCHER_VIEW.debit' | translate}}
              </div>
              <div class="colon">
                  :
              </div>
              <div class="value">
                  {{ voucherData.debit }}
              </div>
          </div>
          <div class="detail">
              <div class="label">
                  {{ 'PAYMENT_VOUCHER_VIEW.credit' | translate}}
              </div>
              <div class="colon">
                  :
              </div>
              <div class="value">
                  {{ voucherData.credit }}
              </div>
          </div>

          <div class="detail">
              <div class="label">
                  {{ 'PAYMENT_VOUCHER_VIEW.amount' | translate}}
              </div>
              <div class="colon">
                  :
              </div>
              <div class="value">
                  <div class="amount">
                     {{ currencySymbol }}  {{ voucherData.amount }}
                  </div>
                  <!-- <div class="amount-in-words">
                      {{ voucherData.amount_in_words }}
                  </div> -->
              </div>
          </div>
          <div class="detail">
              <div class="label">
                  {{ 'PAYMENT_VOUCHER_VIEW.documents' | translate}}
              </div>
              <div class="colon">
                  :
              </div>
              <div class="value">
                <span *ngFor="let item of voucherData.docs">
                  <a href="{{item}}" class="icon" download>
                    <img src="assets/Doc-icon.svg" alt = "">
                  </a>
                </span>
                <span *ngIf="!voucherData.docs.length">
                  N/A
                </span>
              </div>
          </div>

          <div class="detail" style="width:80%; height:55px">
              <div class="label" style="width:22%" >
                  {{ 'PAYMENT_VOUCHER_VIEW.narration' | translate}}
              </div>
              <div class="colon">
                  :
              </div>
              <div class="value">
                  {{ voucherData.narration }}
              </div>
          </div>


      </div>
  </div>
</div>
